"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const FlowEdit_vue_1 = __importDefault(require("@/components/data/FlowEdit.vue"));
const vehicle_1 = __importDefault(require("@/pages/index/api/vehicle"));
const file_1 = require("@/pages/index/utils/file");
const OverdueDetail_vue_1 = __importDefault(require("@/pages/index/components/OverdueDetail.vue"));
const mainData_1 = __importDefault(require("./../mainData"));
const utils_1 = require("@/config/utils");
const preservationFlowConfig_1 = __importDefault(require("../preservationFlowConfig"));
let fromPath = '';
exports.default = (0, vue_1.defineComponent)({
    name: 'GuarantorInfo',
    components: {
        OverdueDetail: OverdueDetail_vue_1.default,
        FlowEdit: FlowEdit_vue_1.default
    },
    data() {
        return {
            mainData: mainData_1.default,
            detail: undefined,
            flow: {
                data: preservationFlowConfig_1.default,
                key: undefined
            }
        };
    },
    beforeRouteEnter(to, from) {
        // 在渲染该组件的对应路由被验证前调用
        // 不能获取组件实例 `this` ！
        // 因为当守卫执行时，组件实例还没被创建！
        fromPath = from.fullPath !== '/' ? from.fullPath : '';
    },
    computed: {
        id() {
            return this.$route.params.id === 'build' ? undefined : this.$route.params.id;
        },
        isOperating() {
            return this.mainData.$getStatus('operate') === 'ing';
        },
        currentParams() {
            const params = this.$route.params;
            return {
                overdueRecordOrFlowId: (0, utils_1.simpleDecrypt)(params.overdueRecordOrFlowId),
                flowKey: (0, utils_1.simpleDecrypt)(params.flowKey)
            };
        },
        overdueRecordId() {
            if (this.id) {
                if (this.detail) {
                    return this.detail.overdueRecordId;
                }
                else {
                    return undefined;
                }
            }
            else {
                return this.currentParams.overdueRecordOrFlowId;
            }
        },
        isFinished() {
            if (this.detail) {
                return this.detail.applyStatus.status !== 'ing';
            }
            else {
                return false;
            }
        }
    },
    watch: {
        id() {
            this.$nextTick(() => {
                this.init();
            });
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.detail = undefined;
            const flowEdit = this.$refs['flow-edit'];
            if (this.id) {
                (0, file_1.getFileWithPromise)(vehicle_1.default.vehiclePreservationInfo.require({
                    id: this.id
                }), this.id, 'preservationFile').then(res => {
                    const detail = this.mainData.$createDataByDictionary(res.data);
                    detail.fileList = [];
                    if (res.file) {
                        res.file.forEach(item => {
                            detail.fileList.push(item);
                        });
                    }
                    this.detail = detail;
                    this.flow.key = this.currentParams.flowKey;
                    flowEdit.init(this.flow.key, this.detail);
                });
            }
            else {
                flowEdit.init();
            }
        },
        onBack(toFrom) {
            if (fromPath && toFrom) {
                // 存在来源路径切需要跳转回来源时，通过back回退
                this.$router.replace(fromPath);
            }
            else {
                this.$router.replace('/home');
            }
        }
    }
});
